import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => (
    <>
        <g clipPath="url(#clip0_849_2576)">
            <path
                d="M17.9167 10.0835C19.9417 10.0835 21.5833 11.7251 21.5833 13.7502C21.5833 15.7752 19.9417 17.4168 17.9167 17.4168L5.99999 17.4169C3.46868 17.4169 1.41666 15.3647 1.41666 12.8334C1.41666 10.4042 3.30688 8.41649 5.69652 8.26008C6.72433 6.08687 8.93639 4.5835 11.5 4.5835C14.7328 4.5835 17.4077 6.97418 17.8522 10.0841C17.8738 10.0837 17.895 10.0835 17.9167 10.0835Z"
                stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <ellipse cx="7.83332" cy="12.3752" rx="0.916667" ry="0.916667" fill={color}/>
            <circle cx="11.5" cy="12.3752" r="0.916667" fill={color}/>
            <ellipse cx="15.1667" cy="12.3752" rx="0.916667" ry="0.916667" fill={color}/>
        </g>
        <defs>
            <clipPath id="clip0_849_2576">
                <rect width="22" height="22" fill={color} transform="translate(0.5)"/>
            </clipPath>
        </defs>
    </>
)

export const CloudProcess: React.FC<IconProps> = ({color, size}) => <IconWrapper {...{size, color, renderIcon}} />
